"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const HttpService_1 = require("../../Components/Http/HttpService");
const HttpUtil_1 = require("../../Components/Http/HttpUtil");
const RequestMethod_1 = require("../../Components/Http/RequestMethod");
class HttpClient {
    constructor(httpService) {
        this.httpService = httpService !== null && httpService !== void 0 ? httpService : new HttpService_1.default();
    }
    /**
     * Send a Http Request
     */
    send(request) {
        return this.httpService.send(request);
    }
    /**
     * Abort the currently running request, if any
     */
    abort() {
        this.httpService.abort();
    }
    /**
     * Download GET request
     */
    download(url, query, headers) {
        return this.httpService.send({
            url,
            method: RequestMethod_1.default.GET,
            query,
            headers
        }).then(response => HttpUtil_1.default.handleDownloadResponse(response));
    }
    /**
     * GET request
     */
    get(url, query, headers) {
        return this.httpService.send({
            url,
            method: RequestMethod_1.default.GET,
            query,
            headers
        });
    }
    /**
     * OPTIONS request
     */
    options(url, query, headers) {
        return this.httpService.send({
            url,
            method: RequestMethod_1.default.OPTIONS,
            query,
            headers
        });
    }
    /**
     * HEAD request
     */
    head(url, query, headers) {
        return this.httpService.send({
            url,
            method: RequestMethod_1.default.HEAD,
            query,
            headers
        });
    }
    /**
     * POST request
     */
    post(url, body, headers) {
        return this.httpService.send({
            url,
            method: RequestMethod_1.default.POST,
            body,
            headers
        });
    }
    /**
     * DELETE request
     */
    delete(url, query, headers) {
        return this.httpService.send({
            url,
            method: RequestMethod_1.default.DELETE,
            query,
            headers
        });
    }
    /**
     * PUT request
     */
    put(url, body, headers) {
        return this.httpService.send({
            url,
            method: RequestMethod_1.default.PUT,
            body,
            headers
        });
    }
    /**
     * PATCH request
     */
    patch(url, body, headers) {
        return this.httpService.send({
            url,
            method: RequestMethod_1.default.PATCH,
            body,
            headers
        });
    }
    /**
     * Trigger a file download for the given url
     */
    static download(url, query, headers) {
        return HttpClient.defaultHttpClient.download(url, query, headers);
    }
    /**
     * GET request
     */
    static get(url, query, headers) {
        return HttpClient.defaultHttpClient.get(url, query, headers);
    }
    /**
     * OPTIONS request
     */
    static options(url, query, headers) {
        return HttpClient.defaultHttpClient.options(url, query, headers);
    }
    /**
     * HEAD request
     */
    static head(url, query, headers) {
        return HttpClient.defaultHttpClient.head(url, query, headers);
    }
    /**
     * POST request
     */
    static post(url, body, headers) {
        return HttpClient.defaultHttpClient.post(url, body, headers);
    }
    /**
     * DELETE request
     */
    static delete(url, query, headers) {
        return HttpClient.defaultHttpClient.delete(url, query, headers);
    }
    /**
     * PUT request
     */
    static put(url, body, headers) {
        return HttpClient.defaultHttpClient.put(url, body, headers);
    }
    /**
     * PATCH request
     */
    static patch(url, body, headers) {
        return HttpClient.defaultHttpClient.patch(url, body, headers);
    }
}
HttpClient.defaultHttpClient = new HttpClient(new HttpService_1.default());
exports.default = HttpClient;
//# sourceMappingURL=HttpClient.js.map